import React from 'react';
import PropTypes from 'prop-types';
import { getDisplayName } from 'recompose';

import makeCancelable from './makeCancelable';

const withPromiseCancelHandler = (WrappedComponent) => {
    class PromiseCancel extends React.PureComponent {
        constructor(props) {
            super(props);

            this.promises = new Map();
            this.index = 0;

            this.addCancelablePromise = this.addCancelablePromise.bind(this);
            this.cancelPendingPromises = this.cancelPendingPromises.bind(this);
        }

        componentWillUnmount() {
            this.cancelPendingPromises();
        }

        addCancelablePromise(promise) {
            const cancelable = makeCancelable(promise);
            const key = this.index;


            this.promises.set(key, cancelable);
            this.index += 1;

            return cancelable.promise
                .then((...args) => {
                    this.promises.delete(key);

                    return Promise.resolve(...args);
                })
                .catch((...args) => {
                    this.promises.delete(key);

                    // eslint-disable-next-line prefer-promise-reject-errors
                    return Promise.reject(...args);
                });
        }

        cancelPendingPromises() {
            this.promises.forEach((cancelablePromise) => {
                cancelablePromise.cancel();
            });

            this.promises = new Map();
            this.index = 0;
        }

        render() {
            return (
                <WrappedComponent
                    {...this.props}
                    addCancelablePromise={this.addCancelablePromise}
                />
            );
        }
    }

    PromiseCancel.displayName = `withPromiseCancel(${getDisplayName(WrappedComponent)})`;

    return PromiseCancel;
};

export const propTypes = {
    addCancelablePromise: PropTypes.func.isRequired,
};

export default withPromiseCancelHandler;
